import React, {useEffect, useState} from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

import {
  Add,
  Close,
  DeleteOutline,
  Inventory2Outlined,
  Remove,
  VisibilityOutlined,
} from "@mui/icons-material";
import axios from "axios";
import { Base_Uri } from "../Constant/BaseUri";
import useScanDetection from "use-scan-detection";

const ProductManager = ({
  jobId,
  jobStatus,
  initialProducts = [],
//   availableProducts = [],
  onSave,
  buttonText = "View Products",
}) => {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [productChanges, setProductChanges] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedQty, setSelectedQty] = useState(1);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [availableProducts, setAvailableProducts] = useState([]);
// const [selectedProduct, setSelectedProduct] = useState(null);
const [searchValueProduct, setSearchValueProduct] = useState("");
const [productLoading, setProductLoading] = useState(false);
const [whichWise,setWhichWise] = useState("1") //1 is only product and 0 is all


const [barcodeRead,setBarcodeRead] = useState("")


useScanDetection({
    onComplete: (code) => {
      //console.log(code)

        // Blur all buttons
        document.querySelectorAll("button").forEach(button => button.blur());

        // Blur all input fields and clear their values
        document.querySelectorAll("input").forEach(input => {
            input.blur();
            input.value = ""; // Clear input value
        });

        // Set the scanned barcode
        setBarcodeRead(String(code).split("Shift").join(""));
        //console.log(code)
    },
    minLength: 3,
});


  const fetchProducts = async (
  page = 0,
  limit = 20,
  searchValue = "",
) => {
  try {
    setProductLoading(true);

    let userData = sessionStorage.getItem("userData");
    userData = userData ? JSON.parse(userData) : null;

    const token = userData;

    const response = await axios.get(
      `${Base_Uri}getProducts`,
      {
        params: {
          page: page + 1,
          limit,
          pag: 1,
          search: searchValue.trim(),
          product:whichWise==="1"?whichWise:""
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    setAvailableProducts(response?.data?.data || []);
  } catch (error) {
    console.error("Failed to fetch products:", error);
    setAvailableProducts([]);
  } finally {
    setProductLoading(false);
  }
};

useEffect(() => {
  if (open) {
    fetchProducts(0, 20, "");
    
  }
}, [open]);
useEffect(() => {
  if (barcodeRead) {
    fetchProducts(0, 20, barcodeRead);
    
  }
}, [barcodeRead]);

useEffect(() => {
  if (!open) {
    return;
  }

  const timer = setTimeout(() => {
    fetchProducts(0, 20, searchValueProduct);
  }, 500);

  return () => {
    clearTimeout(timer);
  };
}, [searchValueProduct, open]);
  const isCollected =
    String(jobStatus || "").trim().toLowerCase() === "collected";

  const canEditProducts = !isCollected;

  const getProductId = product => {
    if (!product) {
      return null;
    }

    if (
      product.productId &&
      typeof product.productId === "object"
    ) {
      return product.productId._id || product.productId.id;
    }

    return product.productId || product._id || product.id;
  };

  const getProductName = product => {
    if (!product) {
      return "-";
    }

    if (
      product.productId &&
      typeof product.productId === "object"
    ) {
      return (
        product.productName ||
        product.name ||
        product.productId.productName ||
        product.productId.name ||
        product.productData.name ||
        "-"
      );
    }

    return product.productName || product.name ||product?.product_name||product.productData.name|| "-";
  };

  const getProductPrice = product => {
    if (!product) {
      return 0;
    }

    if (
      product.productId &&
      typeof product.productId === "object"
    ) {
      return (
        product.retail_price ??
        product.salePrice ??
        product.productId.price ??
        product.productId.salePrice ??
        0
      );
    }

    return product.retail_price ?? product.salePrice ??product.unitPrice?? 0;
  };

  const normalizeProduct = (product,neww=false) => {
    const nestedProduct =
      product?.productId &&
      typeof product.productId === "object"
        ? product.productId
        : {};

    if (neww) {
        return {
      ...nestedProduct,
      ...product?.productData,
      retail_price:product?.unitPrice,
      productId: getProductId(product),

      qty: Math.max(
        1,
        Number(product?.qty ?? product?.quantity ?? 1) || 1,
      ),
    };
    }else{
        return {
      ...nestedProduct,
      ...product,
      productId: getProductId(product),

      qty: Math.max(
        1,
        Number(product?.qty ?? product?.quantity ?? 1) || 1,
      ),
    };
    }
  };
console.log(initialProducts,"initialProducts")
  useEffect(() => {
    if (!open) {
      return;
    }

    setProducts(initialProducts.map(normalizeProduct,true));
    setProductChanges([]);
    setSelectedProduct(null);
    setSelectedQty(1);
    setError("");
  }, [open,initialProducts]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (saving) {
      return;
    }

    setOpen(false);
  };

  const updateProductQty = (currentProducts, productId, newQty) => {
    return currentProducts.map(product => {
      const currentProductId = getProductId(product);

      if (String(currentProductId) !== String(productId)) {
        return product;
      }

      return {
        ...product,
        qty: newQty,
      };
    });
  };

  const handleAddProduct = () => {
    if (!canEditProducts || !selectedProduct) {
      return;
    }

    const productId = getProductId(selectedProduct);
    const qty = Math.max(1, Number(selectedQty) || 1);

    if (!productId) {
      setError("Selected product does not have a valid product ID.");
      return;
    }

    setError("");

    setProducts(previousProducts => {
      const existingProduct = previousProducts.find(product => {
        return (
          String(getProductId(product)) === String(productId)
        );
      });

      if (existingProduct) {
        const previousQty =
          Number(existingProduct.qty) || 0;

        const newQty = previousQty + qty;

        setProductChanges(previousChanges => [
          ...previousChanges,
          {
            productId,
            previousQty,
            newQty,
            status: "add",
          },
        ]);

        return updateProductQty(
          previousProducts,
          productId,
          newQty,
        );
      }

      const newProduct = {
        ...normalizeProduct(selectedProduct),
        productId,
        qty,
      };

      setProductChanges(previousChanges => [
        ...previousChanges,
        {
          productId,
          qty,
          status: "new",
        },
      ]);

      return [...previousProducts, newProduct];
    });

    setSelectedProduct(null);
    setSearchValueProduct("");
    setSelectedQty(1);
  };

  const handleIncreaseQty = productId => {
    if (!canEditProducts) {
      return;
    }

    setProducts(previousProducts => {
      const product = previousProducts.find(item => {
        return (
          String(getProductId(item)) === String(productId)
        );
      });

      if (!product) {
        return previousProducts;
      }

      const previousQty = Number(product.qty) || 0;
      const newQty = previousQty + 1;

      setProductChanges(previousChanges => [
        ...previousChanges,
        {
          productId,
          previousQty,
          newQty,
          status: "add",
        },
      ]);

      return updateProductQty(
        previousProducts,
        productId,
        newQty,
      );
    });
  };

  const handleDecreaseQty = productId => {
    if (!canEditProducts) {
      return;
    }

    setProducts(previousProducts => {
      const product = previousProducts.find(item => {
        return (
          String(getProductId(item)) === String(productId)
        );
      });

      if (!product) {
        return previousProducts;
      }

      const previousQty = Number(product.qty) || 0;

      if (previousQty <= 1) {
        return previousProducts;
      }

      const newQty = previousQty - 1;

      setProductChanges(previousChanges => [
        ...previousChanges,
        {
          productId,
          previousQty,
          newQty,
          status: "minus",
        },
      ]);

      return updateProductQty(
        previousProducts,
        productId,
        newQty,
      );
    });
  };

  const handleDeleteProduct = productId => {
    if (!canEditProducts) {
      return;
    }

    setProducts(previousProducts => {
      const productExists = previousProducts.some(product => {
        return (
          String(getProductId(product)) ===
          String(productId)
        );
      });

      if (!productExists) {
        return previousProducts;
      }

      setProductChanges(previousChanges => [
        ...previousChanges,
        {
          productId,
          newQty: 0,
          status: "delete",
        },
      ]);

      return previousProducts.filter(product => {
        return (
          String(getProductId(product)) !==
          String(productId)
        );
      });
    });
  };

  const handleSave = async () => {
    if (!canEditProducts || productChanges.length === 0) {
      return;
    }

    const payload = {
      ...(jobId ? {jobId} : {}),

      products: products.map(product => ({
        productId: getProductId(product),
        qty: Number(product.qty) || 0,
      })),

      productChanges,
    };

    try {
      setSaving(true);
      setError("");

      if (typeof onSave === "function") {
        await onSave(payload);
      } else {
        console.log("Product payload:", payload);
      }

      setOpen(false);
    } catch (saveError) {
      console.error("Product save error:", saveError);

      setError(
        saveError?.response?.data?.message ||
          saveError?.message ||
          "Unable to save product changes.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="text"
        startIcon={<VisibilityOutlined />}
        onClick={handleOpen}
        sx={{
          minWidth: "auto",
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        {buttonText}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Inventory2Outlined color="primary" />

            <Box>
              <Typography variant="h6" fontWeight={700}>
                Product Manager
              </Typography>

              <Typography variant="body2" color="text.secondary">
                View and manage products for this repair job.
              </Typography>
            </Box>
          </Stack>

          <IconButton
            onClick={handleClose}
            disabled={saving}
            aria-label="Close product manager"
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{p: 3}}>
          <Stack spacing={3}>
            {isCollected && (
              <Alert severity="warning">
                This repair job has been collected. Products
                can only be viewed. Add, quantity changes and
                deletion are disabled.
              </Alert>
            )}

            {error && (
              <Alert
                severity="error"
                onClose={() => setError("")}
              >
                {error}
              </Alert>
            )}

            <Box>
              <Typography
                variant="subtitle1"
                fontWeight={700}
                mb={1.5}
              >
                Add Product
              </Typography>

              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}
                spacing={1.5}
                alignItems={{
                  xs: "stretch",
                  sm: "flex-start",
                }}
              >
               <Autocomplete
  fullWidth
  options={availableProducts}
  value={selectedProduct}
  inputValue={searchValueProduct}
  loading={productLoading}
  disabled={!canEditProducts}
  sx={{
                    width: {
                      xs: "100%",
                      sm: 400,
                    },
                  }}

  filterOptions={options => options}

  onInputChange={(event, newInputValue, reason) => {
    if (reason === "input" || reason === "clear") {
      setSearchValueProduct(newInputValue);
    }
  }}

  onChange={(event, newValue) => {
    setSelectedProduct(newValue);

    if (newValue) {
      setSearchValueProduct(getProductName(newValue));
    }
  }}

  isOptionEqualToValue={(option, value) =>
    String(getProductId(option)) ===
    String(getProductId(value))
  }

  getOptionLabel={option => {
    if (typeof option === "string") {
      return option;
    }

    return getProductName(option);
  }}

  noOptionsText={
    searchValueProduct.trim()
      ? "No products found"
      : "Type to search products"
  }

  renderOption={(props, option) => {
    const productId = getProductId(option);
    const productName = getProductName(option);
    const productPrice =
      option?.retail_price ??
      option?.price ??
      option?.retailPrice ??
      0;

    const stock =
      option?.qty ??
      option?.quantity ??
      option?.stock ??
      0;

    return (
      <li {...props} key={productId}>
        <div style={{width: "100%"}}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            <strong>{productName}</strong>

            <span>
              Price: {productPrice}
            </span>
          </div>

          <div
            style={{
              marginTop: 3,
              fontSize: 12,
              color: "#777",
            }}
          >
            Stock: {stock}
          </div>
        </div>
      </li>
    );
  }}

  renderInput={params => (
    <TextField
      {...params}
      label="Select Product"
      placeholder="Type product name, barcode or SKU"
      size="small"
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {productLoading ? (
              <CircularProgress
                color="inherit"
                size={18}
              />
            ) : null}

            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  )}
/>
<Select
    labelId="which-wise-label"
    id="which-wise"
    label="By"
    value={whichWise}
    disabled={!canEditProducts}
    onChange={(event) => {
      setWhichWise(event.target.value);
    }}
    sx={{
                    width: {
                      xs: "100%",
                      sm: 130,
                    },
                    height:40
                  }}
  >
    <MenuItem value="1">Product Name</MenuItem>
    <MenuItem value="0">By All</MenuItem>
  </Select>
                <TextField
                  type="number"
                  label="Quantity"
                  size="small"
                  value={selectedQty}
                  disabled={!canEditProducts}
                  onChange={event => {
                    const value = Number(event.target.value);

                    setSelectedQty(
                      value > 0 ? Math.floor(value) : 1,
                    );
                  }}
                  inputProps={{
                    min: 1,
                    step: 1,
                  }}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: 130,
                    },
                  }}
                />

                <Button
                  variant="contained"
                  startIcon={<Add />}
                  disabled={
                    !canEditProducts || !selectedProduct
                  }
                  onClick={handleAddProduct}
                  sx={{
                    minWidth: 135,
                    minHeight: 40,
                    whiteSpace: "nowrap",
                  }}
                >
                  Add Product
                </Button>
              </Stack>
            </Box>

            <Divider />

            <Box>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                mb={1.5}
              >
                <Typography variant="subtitle1" fontWeight={700}>
                  Added Products
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  Total products: {products.length}
                </Typography>
              </Stack>

              <TableContainer
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "action.hover",
                      }}
                    >
                      <TableCell>
                        <strong>Product</strong>
                      </TableCell>

                      <TableCell>
                        <strong>Price</strong>
                      </TableCell>

                      <TableCell align="center">
                        <strong>Quantity</strong>
                      </TableCell>

                      <TableCell align="right">
                        <strong>Actions</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {products.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          align="center"
                          sx={{
                            py: 5,
                            color: "text.secondary",
                          }}
                        >
                          No products added.
                        </TableCell>
                      </TableRow>
                    ) : (
                      products.map(product => {
                        const productId =
                          getProductId(product);

                        const quantity =
                          Number(product.qty) || 0;

                        return (
                          <TableRow key={String(productId)}>
                            <TableCell>
                              <Typography fontWeight={600}>
                                {getProductName(product)}
                              </Typography>

                              {/* <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                ID: {productId}
                              </Typography> */}
                            </TableCell>

                            <TableCell>
                              {getProductPrice(product)}
                            </TableCell>

                            <TableCell align="center">
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                spacing={0.5}
                              >
                                <Tooltip title="Decrease quantity">
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        !canEditProducts ||
                                        quantity <= 1
                                      }
                                      onClick={() =>
                                        handleDecreaseQty(
                                          productId,
                                        )
                                      }
                                    >
                                      <Remove fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>

                                <Typography
                                  fontWeight={700}
                                  sx={{
                                    minWidth: 30,
                                    textAlign: "center",
                                  }}
                                >
                                  {quantity}
                                </Typography>

                                <Tooltip title="Increase quantity">
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={!canEditProducts}
                                      onClick={() =>
                                        handleIncreaseQty(
                                          productId,
                                        )
                                      }
                                    >
                                      <Add fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </Stack>
                            </TableCell>

                            <TableCell align="right">
                              <Tooltip title="Delete product">
                                <span>
                                  <IconButton
                                    size="small"
                                    color="error"
                                    disabled={!canEditProducts}
                                    onClick={() =>
                                      handleDeleteProduct(
                                        productId,
                                      )
                                    }
                                  >
                                    <DeleteOutline fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {canEditProducts &&
              productChanges.length > 0 && (
                <Alert severity="info">
                  {productChanges.length} unsaved product{" "}
                  {productChanges.length === 1
                    ? "change"
                    : "changes"}
                  .
                </Alert>
              )}
          </Stack>
        </DialogContent>

        <DialogActions sx={{px: 3, py: 2}}>
          <Button
            onClick={handleClose}
            disabled={saving}
            color="inherit"
          >
            {isCollected ? "Close" : "Cancel"}
          </Button>

          {!isCollected && (
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={
                saving || productChanges.length === 0
              }
              startIcon={
                saving ? (
                  <CircularProgress size={18} color="inherit" />
                ) : null
              }
            >
              {saving ? "Saving..." : "Save Changes"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProductManager;